import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from 'angular-calendar';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-custom-datepicker',
  templateUrl: './custom-datepicker.component.html',
  styleUrl: './custom-datepicker.component.scss',
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class CustomDatepickerComponent {
  @Input() placeholder: string;
  @Input() label: string;
  @Input() innerClass: string;
  @Input() required: boolean = true;
  @Input() hintText: string;
  @Input() controlName: string;
  @Input() errorMessage: string;
  @Input() disabled: boolean;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() parentForm: FormGroup;
  /** Block keyboard typing — the value can only be set via the calendar picker. */
  @Input() readonly = false;
  /** Show a clear (×) button that resets the value when set. */
  @Input() clearable = false;

  get hasValue(): boolean {
    return !!this.parentForm?.get(this.controlName)?.value;
  }

  clear(event: Event): void {
    event.stopPropagation();
    const ctrl = this.parentForm?.get(this.controlName);
    ctrl?.setValue(null);
    ctrl?.markAsDirty();
  }

  get inError(): boolean {
    // if (this.parentForm) {
    //   // @ts-ignore
    //   return (
    //     this.parentForm?.get(this.parentGroupName)?.get(this.controlName)
    //       ?.invalid &&
    //     this.parentForm?.get(this.parentGroupName)?.get(this.controlName)
    //       ?.touched
    //   );
    // }
    // if (this.arrayName) {
    //   // @ts-ignore
    //   const arrayForm = this.parentForm.get(this.arrayName) as FormArray;
    //   // @ts-ignore
    //   return (
    //     arrayForm.controls[this.parentGroupName]?.get(this.controlName)
    //       ?.invalid &&
    //     arrayForm.controls[this.parentGroupName]?.get(this.controlName)?.touched
    //   );
    // }
    // @ts-ignore
    return (
      this.parentForm?.get(this.controlName)?.invalid &&
      this.parentForm?.get(this.controlName)?.touched
    );
  }
}
